/**
 * Componente para mostrar los archivos que el usuario tenga almacenados en Firebase.
 * Permite subir archivos y descargarlos. 
**/

import { useState, useEffect } from 'react';
import { useAuth } from '../db/AuthContext';
import { } from '../db/FirebaseConfig';
import { listUserFiles, deleteUserFile } from "../db/StorageManager";
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import '../assets/File.css';

//imports iconos
import Cloud from "../assets/icons/cloud-upload.svg";
import Carpeta from "../assets/icons/carpeta-abierta-azul.svg";
import Back from "../assets/icons/back.svg";

function Files() {

  /*********************************** VARIABLES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  const [error, setError] = useState(null);
  const [currentUser, setUser] = useState(null);
  const [currentPath, setCurrentPath] = useState("");
  const [successDelete, setSuccessDelete] = useState(false);
  const { user } = useAuth();
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);

  //las extensiones de archivos que se permite subir a Firebase (NO IMPLEMENTADO)
  const allowedExtensions = ['png', 'jpg', 'jpeg', 'fbx', 'gltf', 'mp4'];

  /***********************************************************************************************/
  /***********************************************************************************************/

  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //se actualiza el usuario al intentar navegar a la página
  useEffect(() => {
    setUser(user);
  }, [user]);
  
  //se muestran los archivos y directorios una vez se recupera el user autenticado y se actualiza cada
  //vez que se cambia de directorio
  useEffect(() => {
    if (!currentUser) return;
    
    const fetchData = async () => {
      const { files, folders } = await listUserFiles(currentUser.uid, currentPath);
      setFiles(files);
      setFolders(folders);
    };

    fetchData();
  }, [currentUser, currentPath, successDelete]);

  //se encarga de borrar el archivo que se pasa como parámetro (NO IMPLEMENTADO)
  const handleDelete = async (fileName) => {  
    const success = await deleteUserFile(currentUser, currentPath, fileName);
  
    //se cambia el estado de la variable para que recargue los archivos
    if (success) {
      setSuccessDelete(!successDelete);
    }
  };

  //Gestiona el cambio de carpeta cuando se navega a una distinta a la actual
  const handleFolderClick = (folderName) => {
    //Se actualiza la ruta actual
    const newPath = currentPath ? `${currentPath}/${folderName}` : folderName;
    setCurrentPath(newPath);
  };

  //Gestiona volver a una carpeta más arriba en la jerarquía
  const handleBackClick = () => {
    const pathArray = currentPath.split('/');
    pathArray.pop(); //Se quita el último elemento de la ruta
    setCurrentPath(pathArray.join('/'));
  };

  //Gestiona descargar las imágenes cuando se clickan
  const handleDownload = async (url, name) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.target = "_blank"; //Se abre en una nueva pestaña
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /***********************************************************************************************/
  /***********************************************************************************************/

  return (
    <div className="files-container">
      <Navbar />
      <div className="files-wrapper">
        <Sidebar />
        <main className="files-main">
          <h5>Mis archivos</h5>
          <div className="espacio-doble" />
          {error && <div className="error-message">{error}</div>}
          <div> 
            {currentPath && (
              <button className="files-backBox" onClick={handleBackClick}>
                <img src={Back} alt="Foto carpeta" className="files-iconoBox"/>
              </button>
            )}
            <div className="files-imageGallery">
              <ul className="files-boxContainer">
                {folders.map((folder, index) => (
                  <li key={index} className="files-folderBox" onClick={() => handleFolderClick(folder)}>
                    <img src={Carpeta} alt="Foto carpeta" className="files-iconoBox"/>
                    {folder}
                  </li>
                ))}
              </ul>
            </div>    
            <p></p>
            <div className="files-imageGallery">  
              <ul className="files-boxContainer">
                {files.map((file, index) => (
                  <li key={index} className="files-fileBox">
                    {/* <button onClick={() => handleDelete(file.name)} className="botonX">X</button> */}
                    <img
                      src={file.url} alt={file.name}
                      className="files-fileBox--image"
                      onClick={() => handleDownload(file.url, file.name)}
                    />
                    <span className="files-fileBox--texto">{file.name}</span>  
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {/* DROP ZONE PARA SUBIR ARCHIVOS */}
          {/* <div className="drop-zone">
            <img src={Cloud} alt="Foto nube" />
            <p></p>
            <span className="drop-texto">Arrastra y suelta archivos aquí</span>
            <span className="drop-textoAlt">o usa el botón "Import" para subir</span>
          </div> */}
        </main>
      </div>
    </div>
  );
}

export default Files;